import React from "react";
import styled from "styled-components";
import { H3 } from "components";
import colors from "theme/colors";

export const ProductDetailPanelHeader = styled(H3)`
  margin: 0;
  padding: 6px 16px 6px;
`;

export interface ProductDetailPanelTitleProps {
  readonly children: React.ReactNode;
}

export function ProductDetailPanelTitle({
  children,
}: ProductDetailPanelTitleProps) {
  return (
    <ProductDetailPanelHeader bold color={colors.muttedHeadlines}>
      {children}
    </ProductDetailPanelHeader>
  );
}

/** For titles paired with inline actions (e.g. add buttons). */
export const ProductDetailPanelHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
  padding: 6px 16px 6px;
`;

export const ProductDetailPanelHeaderInline = styled(ProductDetailPanelHeader)`
  padding: 0;
  margin-right: 16px;
`;
